import ImportShopReceipts from './ImportShopReceipts';

export default ImportShopReceipts;
